unit DisposableListScreenType;
{

/* Initial. */

}

interface

uses
  CategoryItemListType, DisposableItemListType, SupplierItemListType, TypeListType;

type
  TDisposableListScreenType = class
  private
    fDisposableItemList: TDisposableItemListType;
    fSupplierItemList: TSupplierItemListType;
    fTypeList: TTypeListType;
  public
    property DisposableItemList: TDisposableItemListType read fDisposableItemList;
    property SupplierItemList: TSupplierItemListType read fSupplierItemList;
    property TypeList: TTypeListType read fTypeList;
  end;

implementation

end.
